import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import Back from 'app/components/SVGS/Back'
import FavoriteActivitiesFilters from '../FavoriteActivitiesFilters'
import { getFavoriteActivitiesListSize } from 'store/entities/favoriteActivities/selectors'
import './styles.scss'

const mapStateToProps = state => ({
  size: getFavoriteActivitiesListSize(state),
})

const bc = 'favorite-activities-header'

const FavoriteActivitiesHeader = ({ t, size }) => (
  <div className={bc}>
    <div className={`${bc}__left-part`}>
      <div className={`${bc}__back`}>
        <Link to="/dashboard" className="btn organizations-header__iconbtn">
          <Back />
          <span className={`${bc}__back-text`}>{t('Back')}</span>
        </Link>
      </div>
      <div className={`${bc}__title`}>{t('user:Favorite Activities')}</div>
    </div>
    {size ? <FavoriteActivitiesFilters /> : null}
  </div>
)

FavoriteActivitiesHeader.displayName = 'FavoriteActivitiesHeader'

const FavoriteActivitiesHeaderContainer = connect(mapStateToProps)(FavoriteActivitiesHeader)

FavoriteActivitiesHeaderContainer.displayName = 'FavoriteActivitiesHeaderContainer'

export default withTranslation()(FavoriteActivitiesHeaderContainer)
